export default __webpack_public_path__ + "static/media/samsung.68afa24f.svg";